// Copyright (c) 2016 Deere & Company

import WarrantyLargeModal from './large-modal';
import WarrantyMediumModal from './medium-modal';
import WarrantySimpleModal from './simple-modal';
import WarrantyXlargeModal from './xlarge-modal';

export default {
    WarrantyLargeModal,
    WarrantyMediumModal,
    WarrantySimpleModal,
    WarrantyXlargeModal
};



// WEBPACK FOOTER //
// ./src/shared/components/modal/index.js